import React from "react";
import "./PricingCard.css";

export default function PricingCard({
  title,
  price,
  currency = "USD",
  period = "/month",
  features = [],
  ctaLabel,
  ctaHref = "#",
  highlighted = false,
  badgeText,
  hasFreeTrial,
  planId,
  onCheckout,
  disabled = false,
}) {
  return (
    <div className={`cards-pricing ${highlighted ? 'highlighted' : ''}`}>
      {highlighted && badgeText ? (
        <div className="popular-badge">{badgeText}</div>
      ) : null}

      {hasFreeTrial && !highlighted && (
        <div className="free-trial-badge">
          <span className="free-trial-text">Free trial 30 days</span>
        </div>
      )}

      <h3 className="card-title">{title}</h3>

      <div className="mb-4">
        <div className="text-4xl price">
          {currency} <span className="price">${price}</span>
          <span className="text-lg text-gray-600 font-normal">{period}</span>
        </div>
      </div>

      <ul>
        {features.map((f, idx) => (
          <li key={idx} className="flex items-start font-quicksand text-gray-700">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="tilde-icon"
              fill="none"
              viewBox="0 0 24 24"
              stroke="rgb(239 146 69"
              strokeWidth={2}
            >
              <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
            </svg>
            <span className="feature-text">{f}</span>
          </li>
        ))}
      </ul>

      <button
        type="button"
        disabled={disabled}
        onClick={() => {
          if (disabled) return;
          if (typeof onCheckout === 'function') {
            onCheckout({ planId, price });
          } else {
            window.location.href = ctaHref;
          }
        }}
        className="button-sale"
      >
        {ctaLabel}
      </button>
    </div>
  );
}
